<div class="relative max-w-full min-w-0" [class.z-40]="expandFilterDropdown()">
  <button
    type="button"
    class="group flex h-10 w-fit max-w-full min-w-0 shrink-0 cursor-pointer items-center justify-center gap-1 overflow-hidden border-2 border-brand-primary-pure bg-transparent px-4 py-2 font-roboto text-sm/tight font-medium text-ellipsis whitespace-nowrap text-brand-primary-pure transition-all duration-300 ease-in-out focus-visible:ring-2 focus-visible:ring-brand-primary-pure focus-visible:ring-offset-2 focus-visible:outline-none enabled:hover:border-brand-primary-lighter enabled:hover:bg-brand-primary-lighter enabled:hover:text-brand-primary-dark disabled:cursor-default disabled:opacity-100 data-[expanded=true]:border-brand-primary-lighter data-[expanded=true]:bg-brand-primary-lightest data-[expanded=true]:text-brand-primary-pure data-[expanded=true]:hover:border-brand-primary-lighter data-[expanded=true]:hover:bg-brand-primary-lightest data-[expanded=true]:hover:text-brand-primary-pure"
    [class.rounded-full]="shape() === 'pill'"
    [class.rounded-lg]="shape() === 'rounded'"
    [attr.data-expanded]="expandFilterDropdown()"
    [attr.aria-expanded]="expandFilterDropdown()"
    [attr.aria-label]="ariaLabel()"
    (click)="toggleExpandDropdown()"
    [disabled]="!hasManyOptions()"
  >
    {{ displayLabel() }}
    @if (hasManyOptions()) {
      <ng-icon
        name="featherChevronDown"
        class="size-5 shrink-0 text-brand-primary-pure transition-transform duration-300 group-data-[expanded=true]:rotate-180"
      />
    }
  </button>

  <div
    class="pointer-events-none invisible absolute top-full left-0 z-40 mt-1 flex w-max max-w-[min(100vw-2rem,16.5rem)] min-w-full origin-top scale-y-0 flex-col items-stretch justify-center rounded-md border border-brand-primary-lighter bg-neutral-hight-light p-2 opacity-0 shadow-[0_16px_48px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out data-[expanded=true]:pointer-events-auto data-[expanded=true]:visible data-[expanded=true]:translate-y-1 data-[expanded=true]:scale-y-100 data-[expanded=true]:opacity-100"
    [attr.data-expanded]="expandFilterDropdown()"
  >
    @for (option of visibleOptions(); track option.value) {
      <button
        type="button"
        class="w-full rounded-lg border-0 bg-transparent p-3 text-left font-roboto text-sm/tight text-brand-primary-pure transition-all duration-300 ease-in-out outline-none hover:bg-brand-primary-lighter hover:text-brand-primary-dark focus:bg-brand-primary-pure focus:text-white"
        (click)="handleSelectOption(option.value)"
      >
        {{ option.label }}
      </button>
    }
  </div>
</div>

<div
  class="overlay-panel"
  [class.overlay-panel--active]="expandFilterDropdown()"
  (click)="onClickOutside()"
></div>
